import type { ReactNode } from 'react';
import { Modal } from './Modal';

/** A folder gallery owns its window while each media item owns its playback. */
export function MediaViewerFrame({ embedded, title, className, onClose, actions, children }: {
  embedded?: boolean; title: string; className?: string; onClose: () => void;
  actions?: ReactNode; children: ReactNode;
}) {
  if (embedded) return <>{children}{actions && <footer className="modal__actions file-gallery-actions">{actions}</footer>}</>;
  return <Modal title={title} className={className} size="wide" onClose={onClose} actions={actions}>{children}</Modal>;
}
